<template>
  <div class="contact-form-section section-space--ptb_120" id="contact">
    <div class="container">
      <div class="section-title text-left">
        <h3 class="h3 hero-content-title font-weight-light">Kontakt</h3>
      </div>
      <div class="row">
        <div class="col-lg-7 order-1 order-lg-1">
          <div class="contact-from-wrapper wow move-up">
            <v-form ref="form" id="contact-form" v-model="valid">
              <v-text-field name="con_name" type="text" label="Jméno *" filled flat :rules="required" v-model="mail.name" required></v-text-field>
              <v-text-field name="con_subject" type="text" :rules="required" filled flat v-model="mail.contact" label="Telefon nebo email *" required></v-text-field>
              <v-textarea name="con_message" v-model="mail.message" :rules="rules" filled flat :counter="255" label="Zpráva *" required></v-textarea>
            </v-form>
            <div>
              <div class="contact-submit-btn mt-10">
                <b-alert dismissible variant="success" show v-if="message">{{ message }}</b-alert>
                <v-btn class="ht-btn text-white" text x-large :loading="loadingBtn" :disabled="loadingBtn"  @click="sendMail">Odeslat zprávu</v-btn>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-5 order-2 order-lg-2 text-left">
          <div class="peatures_image-wrap section-space--mb_40 hero-content-title font-weight-light">
            <div class="h5 font-weight-light">
              <strong>
                Radek Stránský<br/>
                Nedašovská 355/3<br/>
                Praha 5, 155 21
              </strong>
            </div>
            <div class="mt-30 mb-30">
              <b-alert show class="d-inline font-weight-bold h5">tel.: 603 918 213</b-alert>
            </div>
            IČ: 74664611<br/>
            Nejsem plátce DPH<br/>
            Platby pouze převodem<br/>
            <p class="mt-20">
              Mám sjednané <a href="https://con1.artatolstatic.com/file/c4a14c3f-f573-44b0-9e7c-cfebaa90eac5.pdf"
                              target="_blank" class="font-weight-bold">pojištění odpovědnosti podnikatelů</a>.<br/>
              Jsem držitelem <a href="https://con1.artatolstatic.com/file/6b212a03-a70d-45d8-b571-e64659828610.pdf"
                                target="_blank" class="font-weight-bold">zdravotního průkazu</a>.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContactForm',
  data() {
    return {
      mail: {
        name: null,
        contact: null,
        message: null,
      },
      message: null,
      loadingBtn: false,
      valid: true,
      rules: [
        value => !!value || 'Pole je nutné vyplnit.',
        value => (value || '').length >= 20 || 'Zpráva musí obsahovat alespoň 20 znaků',
      ],
      required: [
        value => !!value || 'Pole je nutné vyplnit.',
      ],
    }
  },
  methods: {
    sendMail() {
      this.loadingBtn = true
      this.message = null
      this.$refs.form.validate()
      if (this.valid === true) {
        this.$store.dispatch('app/sendMail',{ "name": this.mail.name, "contact": this.mail.contact, "message": this.mail.message }).then(res => {
          if (res == 'ok') {
            this.$refs.form.resetValidation()
            this.$refs.form.reset()
            this.message = "Zpráva byla odeslána. Děkujeme."
          } else {
            this.message = "Zprávu se nepodařilo odeslat!"
          }
          this.loadingBtn = false
        })
      } else {
        this.loadingBtn = false
      }
    }
  }
}
</script>
<style lang="css" scope>
.v-label, .v-label--active {
  left: 0px !important;
  right: auto !important;
  position: absolute;
}
</style>